import { render, staticRenderFns } from "./EmailReceipt.vue?vue&type=template&id=15c2b65e&scoped=true&"
import script from "./EmailReceipt.vue?vue&type=script&lang=ts&"
export * from "./EmailReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./EmailReceipt.vue?vue&type=style&index=0&id=15c2b65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2b65e",
  null
  
)

export default component.exports